import React from "react";

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <h3>Sri Ecovibe Substrates</h3>
      <p>Eco‑Friendly Coir Products for a sustainable future.</p>
      <p>
        <strong>Email:</strong> ecoir@sriecovibe.com | 
        <strong> Phone:</strong> +91 8807606963
      </p>
      <p className="copyright">
        © {new Date().getFullYear()} Sri Ecovibe Substrates. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;